var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessageTime = function SvgMessageTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M44 14.86v12c0 3-1 5.5-2.76 7.26C39.5 35.86 37 36.86 34 36.86v4.26c0 1.6-1.78 2.56-3.1 1.68L22 36.86h-4.24c.16-.6.24-1.22.24-1.86 0-2.04-.78-3.92-2.06-5.34A7.888 7.888 0 0 0 10 27c-2.24 0-4.28.92-5.74 2.42-.18-.8-.26-1.66-.26-2.56v-12c0-6 4-10 10-10h20c6 0 10 4 10 10Z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M18 35c0 2.4-1.06 4.54-2.72 6A8 8 0 0 1 10 43c-4.42 0-8-3.58-8-8 0-2.52 1.16-4.78 3-6.24A8.005 8.005 0 0 1 10 27c4.42 0 8 3.58 8 8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10.5 32.5v3L8 37M17 21h14"
  })));
};
export default SvgMessageTime;